<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="精彩瞬间" name="img">
        <event-order-imgs :order-id="id"></event-order-imgs>
      </el-tab-pane>
      <el-tab-pane label="精彩录像" name="video" :disabled="true"></el-tab-pane>
      <el-tab-pane label="课程日志" name="log" :disabled="true"></el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import EventOrderImgs from "@/components/eventorder/mediaEle/EventOrderImgs.vue";

export default {
  name: 'EventOrderMedia',
  components: {EventOrderImgs},
  props: {
    id: null,
    type: Number
  },

  data() {
    return {
      activeName: "img"
    }
  }


};
</script>

<style scoped>
</style>